import type { Money } from '@/services/api/types';

/**
 * Presentation helpers.
 *
 * Formatting only — no arithmetic. Totals and line amounts always arrive priced
 * from the backend, so there is nothing here that could disagree with what the
 * customer is actually charged.
 */

export function formatMoney(money: Money | undefined, locale: string): string {
  if (!money) return '';

  return new Intl.NumberFormat(locale === 'es' ? 'es-CR' : 'en-US', {
    style: 'currency',
    currency: money.currency,
    maximumFractionDigits: 2,
  }).format(money.amount);
}

/** Renders a minute count as `3h 30m`, dropping empty parts. */
export function formatDuration(minutes: number, locale: string): string {
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  const hourLabel = locale === 'es' ? 'h' : 'h';
  const minuteLabel = 'm';

  if (hours === 0) return `${remainder}${minuteLabel}`;
  if (remainder === 0) return `${hours}${hourLabel}`;
  return `${hours}${hourLabel} ${remainder}${minuteLabel}`;
}

export function formatDistance(km: number, locale: string): string {
  return new Intl.NumberFormat(locale === 'es' ? 'es-CR' : 'en-US', {
    maximumFractionDigits: 0,
  }).format(km) + ' km';
}
